export class RestoreAwsOpenSearchDomainRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "AwsOpenSearchDomainRestoreDestination",
            "format": ""
        },
        {
            "name": "indices",
            "baseName": "indices",
            "type": "Array<AwsOpenSearchIndexSelection>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreAwsOpenSearchDomainRequest.attributeTypeMap;
    }
    constructor() {
    }
}
